// Core
import React, { Component } from "react";
import { Draggable } from "react-beautiful-dnd";
import AddIcon from "material-ui/svg-icons/content/add";
import DownloadIcon from "material-ui/svg-icons/content/save";
import EditIcon from "material-ui/svg-icons/image/edit";
import CopyIcon from "material-ui/svg-icons/content/content-copy";
import DeleteIcon from "material-ui/svg-icons/action/delete";
import MoreIcon from "material-ui/svg-icons/navigation/more-vert";
import ShareIcon from "material-ui/svg-icons/social/share";
import IconButton from "material-ui/IconButton";
import Menu from "material-ui/Menu";
import MenuItem from "material-ui/MenuItem";

// Components
import ChecklistGroupItem from "./ChecklistGroupItem";

// Styles & assets
import "./Checklist.css";

class ChecklistGroup extends Component {
  state = {
    open: false
  };

  onOpen = () => {
    this.setState({ open: true });
  };

  onClose = () => {
    this.setState({ open: false });
  };

  onCreate = () => {
    const item = {
      isPreliminary: false,
      standard: "",
      standardUrl: "",
      section: '',
      description: "",
      id: 0
    };
    this.props.onAddEdit({ indexColumn: this.props.title.id, card: item });
    this.onClose();
  };

  onEdit = card => {
    this.props.onAddEdit({ indexColumn: this.props.title.id, card });
    this.onClose();
  };

  onDelete = id => {
    this.props.onDelete({ indexColumn: this.props.title.id, id });
    this.onClose();
  };

  onDeleteChecklist = () => {
    this.props.onDeleteChecklist({ indexColumn: this.props.title.id });
    this.onClose();
  };

  onCopyChecklist = () => {
    const { title, onCopyChecklist, index } = this.props;
    onCopyChecklist({ indexColumn: title.id, index });
    this.onClose();
  };

  onDownloadChecklist = () => {
    const { title, onDownloadChecklist, index } = this.props;
    onDownloadChecklist({ indexColumn: title.id, index });
    this.onClose();
  };

  onEditChecklist = () => {
    const { onEditCheklist } = this.props;
    onEditCheklist();
    this.onClose();
  };

  onShareChecklist = () => {
    const { onShareChecklist } = this.props;
    onShareChecklist();
    this.onClose();
  };

  handleSelectForSharing = (event) => {
    const {isSharingMode, selectForSharing, columnId} = this.props;

    if (isSharingMode) {
      event.preventDefault();
      selectForSharing(columnId);
    }
  };

  render() {
    const title = this.props.title;
    const quotes = this.props.quotes;
    const index = this.props.index;
    const column = this.props.column;
    const open = this.state.open;

    const { isDropDisabled, checklistsToShareIds, columnId } = this.props;

    const isSelected = checklistsToShareIds.indexOf(columnId) !== -1;

    let selectedStyle = {};

    if (isSelected) {
      selectedStyle = {
        boxShadow: "inset 0 100px 0 0 #d3d3d3"
      }
    }
    return (
      <Draggable draggableId={title.id} index={index} isDropDisabled={!isDropDisabled}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            style={{ ...provided.draggableProps.style, marginLeft: "15px" }}
            onClick={this.handleSelectForSharing}
          >
            <div className="header header-group">
              <div>{title.group ? title.group : ''}</div>
            </div>
            <div className="header" style={selectedStyle}>
              <div className="title" {...provided.dragHandleProps}>
                {title.title}
              </div>
              <div
                style={{ height: "45px", width: "45px", position: "relative" }}
              >
                <IconButton onClick={this.onOpen}>
                  <MoreIcon color={"#fff"} />
                </IconButton>
                <Menu id="long-menu" onClose={this.onClose}>
                  <div
                    style={{
                      display: open ? "block" : "none",
                      height: isDropDisabled ? "110px" : "330px",
                      background: "#dedede",
                      position: "absolute",
                      zIndex: 10001,
                      overflow: "hidden"
                    }}
                  >
                    {!isDropDisabled && <MenuItem>
                      <IconButton
                        onClick={this.onCreate}
                        tooltipPosition="bottom-center"
                        tooltip="add new"
                      >
                        <AddIcon />
                      </IconButton>
                    </MenuItem>}
                    {!isDropDisabled && <MenuItem>
                      <IconButton
                        onClick={this.onEditChecklist}
                        tooltipPosition="top-center"
                        tooltip="edit"
                      >
                        <EditIcon />
                      </IconButton>
                    </MenuItem> }
                    {!isDropDisabled && <MenuItem>
                      <IconButton
                        onClick={this.onCopyChecklist}
                        tooltipPosition="bottom-center"
                        tooltip="copy"
                      >
                        <CopyIcon />
                      </IconButton>
                    </MenuItem> }
                    <MenuItem>
                      <IconButton
                        onClick={this.onShareChecklist}
                        tooltipPosition="top-center"
                        tooltip="share"
                      >
                        <ShareIcon />
                      </IconButton>
                    </MenuItem>
                    <MenuItem>
                      <IconButton
                        onClick={this.onDownloadChecklist}
                        tooltipPosition="top-center"
                        tooltip="download"
                      >
                        <DownloadIcon />
                      </IconButton>
                    </MenuItem>
                    {!isDropDisabled && <MenuItem>
                      <IconButton
                        onClick={this.onDeleteChecklist}
                        tooltipPosition="top-center"
                        tooltip="delete"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </MenuItem> }
                  </div>
                </Menu>
                {open && (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      zIndex: 10000
                    }}
                    onClick={this.onClose}
                  />
                )}
              </div>
            </div>
            <ChecklistGroupItem
              columnId={this.props.columnId}
              column={column}
              onEdit={this.onEdit}
              onDelete={this.onDelete}
              listId={title.id}
              listType="CARD"
              quotes={quotes}
              internalScroll={this.props.isScrollable}
              isCombineEnabled={Boolean(this.props.isCombineEnabled)}
              isDropDisabled={isDropDisabled}

              selectedTaskIds={this.props.selectedTaskIds}
              toggleSelectionInGroup={this.props.toggleSelectionInGroup}
              toggleSelection={this.props.toggleSelection}
            />
          </div>
        )}
      </Draggable>
    );
  }
}

export default ChecklistGroup;
